export default __webpack_public_path__ + "static/media/5.3edd428a.jpg";